export default __webpack_public_path__ + "static/8-f08a4867f3e8dd9bf16dca4ce5f9e54c.jpg";